import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { verifyEmail } from "../api/authClient";

export default function VerifyEmailPage() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("verifying");
    const [message, setMessage] = useState("");

    useEffect(() => {
        const token = searchParams.get("token");

        if (!token) {
            setStatus("error");
            setMessage("No verification token provided.");
            return;
        }

        verifyEmail(token)
            .then((response) => {
                setStatus("success");
                setMessage(response.message || "Your email has been verified successfully!");
            })
            .catch((err) => {
                setStatus("error");
                const errorMessage = err.response?.data?.message || "Verification failed. The link may have expired.";
                setMessage(errorMessage);
            });
    }, [searchParams]);

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm w-full max-w-md text-center p-8">
                {status === "verifying" && (
                    <>
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <div className="animate-spin w-8 h-8 border-2 border-gray-300 border-t-gray-900 rounded-full" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-3">Verifying your email...</h2>
                        <p className="text-gray-500">Please wait while we verify your email address.</p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <div className="w-16 h-16 bg-accent-50 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-8 h-8 text-accent-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-accent-600 mb-3">Email Verified!</h2>
                        <p className="text-gray-500 mb-8">{message}</p>
                        <Link to="/login" className="btn-primary inline-flex">
                            Continue to Login
                        </Link>
                    </>
                )}

                {status === "error" && (
                    <>
                        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-8 h-8 text-danger-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-danger-500 mb-3">Verification Failed</h2>
                        <p className="text-gray-500 mb-8">{message}</p>
                        <Link to="/login" className="btn-secondary inline-flex">
                            Back to Login
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
